"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalCustomerUpdatedContract = exports.ExternalCustomerCreatedContract = exports.ExternalCustomerEventDataContract = void 0;
const customers_1 = require("@getgreenline/customers");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const events_1 = require("@getgreenline/events");
class ExternalCustomerAddress {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalCustomerAddress.prototype, "address", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalCustomerAddress.prototype, "city", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalCustomerAddress.prototype, "province", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(() => 'Canada'),
    __metadata("design:type", String)
], ExternalCustomerAddress.prototype, "country", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalCustomerAddress.prototype, "postalCode", void 0);
class ExternalCustomerEventDataContract {
}
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], ExternalCustomerEventDataContract.prototype, "id", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExternalCustomerEventDataContract.prototype, "name", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExternalCustomerEventDataContract.prototype, "cardId", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsEmail)(),
    __metadata("design:type", String)
], ExternalCustomerEventDataContract.prototype, "email", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], ExternalCustomerEventDataContract.prototype, "phone", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], ExternalCustomerEventDataContract.prototype, "birthday", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsIn)(customers_1.GenderRuntimeCheck),
    __metadata("design:type", String)
], ExternalCustomerEventDataContract.prototype, "gender", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => ExternalCustomerAddress),
    (0, class_transformer_1.Transform)((val) => (0, class_transformer_1.plainToClass)(ExternalCustomerAddress, val.obj, { excludeExtraneousValues: true })),
    __metadata("design:type", ExternalCustomerAddress)
], ExternalCustomerEventDataContract.prototype, "address", void 0);
exports.ExternalCustomerEventDataContract = ExternalCustomerEventDataContract;
class ExternalCustomerCreatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.customer = events_1.GreenlineEvent.create(ExternalCustomerEventDataContract, params.customer);
    }
}
exports.ExternalCustomerCreatedContract = ExternalCustomerCreatedContract;
class ExternalCustomerUpdatedContract extends events_1.ExternalEventContract {
    constructor(params) {
        super(params);
        this.customer = events_1.GreenlineEvent.create(ExternalCustomerEventDataContract, params.customer);
    }
}
exports.ExternalCustomerUpdatedContract = ExternalCustomerUpdatedContract;
//# sourceMappingURL=customers.js.map